import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import ViolationLogs from "../pages/ViolationLogs/ViolationLogs"
import Maps from "pages/Map/Maps"
import VehicleCount from "pages/VehicleCount/VehicleCount"
import RegisterVehicle from "../pages/VehicleDetails/RegisterVehicle"

import DeviceManagementTabs from "../pages/DeviceManagement/deviceManagementTabs"
import ChallanSettings from "../pages/Settings/addChallanSettings"
import SMTPSettings from "../pages/Settings/addSmtpConfig"
import UserRoles from "../pages/UserRoles/UserRoles"
import UserManagement from "../pages/UserManagement/UserManagement"
import ViolationsReport from "pages/ViolationLogs/ViolationsReport"
// import ZoneConfig from  "pages/Settings/addZoneConfig"
import ZoneConfig from  "pages/Settings/addDraggableZoneConfig"
import jwt from "jsonwebtoken";

import DefaultPasswordChangeComponent from "pages/UserManagement/DefaultChangePassword"

const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
// var UserPermissions=JSON.parse(decodedToken.userRolePermissions);

// Example of retrieving user roles and permissions from sessionStorage
// var userData = JSON.parse(sessionStorage.getItem("UserRolePermissions"));
var userData = {};
if(decodedToken != null){
  userData = JSON.parse(decodedToken.userRolePermissions);
}

var userPermissions = {}

if(userData != null){
  userPermissions = {
    editViolations: userData.EditViolations,
    vehicleCount: userData.VehicleCount,
    registerDevice: userData.RegisterDevice,
    registerVehicle: userData.RegisterVehicle,
    smtpSettings: userData.SMTP,
    challanSettings: userData.Challan,
    userManagement: userData.UserManagement,
    addUser: userData.AddUser,
    editDeleteUser: userData.EditDeleteUser,
    roleManagement: userData.RoleManagement,
    addRole: userData.AddRole,
    editDeleteRole: userData.EditDeleteRole,
    changePassword: userData.ChangePassword,
    deleteViolations: userData.DeleteViolations,

    dashboard: true,
    violationLogs: true,
    maps: true,
    vehicleCount: true,
    addZoneConfig: true,
    profile: true,
    violationsReport: true,
    defaultPasswordChange: true
};
}

const userRoutes = [
  { path: "/dashboard", component: Dashboard, requiredPermissions: ["dashboard"] },
  { path: "/ViolationLogs", component: ViolationLogs, requiredPermissions: ["violationLogs"]  },
  { path: "/Maps", component: Maps, requiredPermissions: ["maps"]  },
  { path: "/VehicleCount", component: VehicleCount, requiredPermissions: ["vehicleCount"]  },

  { path: "/RegisterVehicle", component: RegisterVehicle, requiredPermissions: ["registerVehicle"] },
  { path: "/DeviceManagementTabs", component: DeviceManagementTabs, requiredPermissions: ["registerDevice"] },
  { path: "/SMTPSettings", component: SMTPSettings, requiredPermissions: ["smtpSettings"] },
  { path: "/ChallanSettings", component: ChallanSettings, requiredPermissions: ["challanSettings"] },
  { path: "/UserRoles", component: UserRoles, requiredPermissions: ["roleManagement"]  },
  { path: "/UserManagement", component: UserManagement, requiredPermissions: ["userManagement"] },

  { path: "/addZoneConfig", component: ZoneConfig, requiredPermissions: ["addZoneConfig"]  },
  { path: "/profile", component: UserProfile, requiredPermissions: ["profile"]  },
  { path: "/ViolationsReport", component: ViolationsReport, requiredPermissions: ["violationsReport"]  },
 
  { path: "/defaultPasswordChange", component: DefaultPasswordChangeComponent, requiredPermissions: ["defaultPasswordChange"]  },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
]

export { userRoutes, authRoutes, userPermissions }